// extracted by mini-css-extract-plugin
export default {"pagination":"ZWgMB","perPage":"hi8Xo","perPageText":"uQ08k","perPageSelect":"lVEiu","controls":"lGt4w","control":"QYhGv","controlsText":"K2CO1"};